import { render, staticRenderFns } from "./HotelNavLink.vue?vue&type=template&id=33154d7b&scoped=true&"
import script from "./HotelNavLink.vue?vue&type=script&lang=js&"
export * from "./HotelNavLink.vue?vue&type=script&lang=js&"
import style0 from "./HotelNavLink.vue?vue&type=style&index=0&id=33154d7b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33154d7b",
  null
  
)

export default component.exports